const SCROLL_AMOUNT_IN_PX = 200;

document.addEventListener("DOMContentLoaded", function () {
    console.log("section-carousel.js loaded");

    const $carouselModule = $(".carousel-section");
    const $carouselArrowsWrapper = $carouselModule.find(".carousel-arrows");
    const $carouselLeftArrow = $carouselArrowsWrapper.find(".arrow-left");
    const $carouselRightArrow = $carouselArrowsWrapper.find(".arrow-right");
    const $carouselWrapper = $carouselModule.find(".carousel-wrapper");
    const $carouselGradient = $carouselWrapper.find(".carousel-gradient");
    const carouselWrapperElement = $carouselWrapper[0];
    
    // Only proceed if we found the carousel wrapper
    if (!$carouselWrapper.length || !carouselWrapperElement) {
        console.error("Carousel wrapper not found");
        return;
    }
    
    // Add custom styling for when the gradient should be hidden
    // Using !important to override any existing styles
    const styleElement = document.createElement('style');
    styleElement.textContent = `
        .carousel-gradient.at-edge {
            opacity: 0 !important;
            visibility: hidden !important;
        }
    `;
    document.head.appendChild(styleElement);
    
    // Function to check if we've scrolled to the right edge and update the gradient
    /**
     * Checks if the carousel is scrolled to the right edge on mobile screens.
     * If the carousel is at or near the right edge (within 20px), adds an 'at-edge' class
     * to the carousel gradient element to modify its appearance. Only functions on mobile
     * screens (width < 768px) as desktop hides the gradient anyway.
     * 
     * @returns {void}
     */
    function checkRightEdge() {
        // Only run on mobile screens (as desktop hides the gradient anyway)
        if (window.innerWidth >= 768) return;
        
        const scrollWidth = carouselWrapperElement.scrollWidth;
        const clientWidth = carouselWrapperElement.clientWidth;
        const scrollLeft = carouselWrapperElement.scrollLeft;
        const maxScroll = scrollWidth - clientWidth;
        
        // Using a larger threshold (20px) for more reliable detection
        const isAtRightEdge = maxScroll - scrollLeft < 20;
        
        // Apply the class that will override the default styling
        if (isAtRightEdge) {
            $carouselGradient.addClass('at-edge');
        } else {
            $carouselGradient.removeClass('at-edge');
        }
    }
    
    // Initial check with slight delay to ensure everything is rendered
    setTimeout(checkRightEdge, 300);
    
    // Event listener for scroll
    $carouselWrapper.on("scroll", function() {
        requestAnimationFrame(checkRightEdge);
    });
    
    // Event listener for left arrow click
    $carouselLeftArrow.on("click", function () {
        const currentScrollPosition = carouselWrapperElement.scrollLeft;
        carouselWrapperElement.scrollTo({
            left: currentScrollPosition - SCROLL_AMOUNT_IN_PX,
            behavior: "smooth",
        });
        
        // Check gradient after scrolling with a delay for the animation
        setTimeout(checkRightEdge, 500);
    });
    
    // Event listener for right arrow click
    $carouselRightArrow.on("click", function () {
        const currentScrollPosition = carouselWrapperElement.scrollLeft;
        carouselWrapperElement.scrollTo({
            left: currentScrollPosition + SCROLL_AMOUNT_IN_PX,
            behavior: "smooth",
        });
        
        // Check gradient after scrolling with a delay for the animation
        setTimeout(checkRightEdge, 500);
    });
    
    // Handle window resize
    $(window).on('resize', function() {
        setTimeout(checkRightEdge, 300);
    });
});
